import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from 'classnames';
import styles from './AlertActionButton.module.scss.js';
import { applyCommonProps } from '../utility/commonProps.js';
import { getTarget } from '../utility/getTarget.js';
import { onAnchorKeyDown } from '../utility/onAnchorKeyDown.js';

var _excluded = ["className"],
  _excluded2 = ["children", "href", "onClick", "onKeyDown", "target"];
var isAnchor = function isAnchor(props) {
  return 'href' in props;
};

/**
 * @private
 */
var AlertActionButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _applyCommonProps = applyCommonProps(props, AlertActionButton),
    className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  var classes = classNames(styles.action, className);
  if (isAnchor(props)) {
    var _ref = rest,
      children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      anchorOnKeyDown = _ref.onKeyDown,
      target = _ref.target,
      anchorProps = _objectWithoutProperties(_ref, _excluded2);

    // Looks like a button should act like a button.
    //
    // @see {@link https://jira.walmart.com/browse/LD-374?focusedCommentId=12802856&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-12802856}
    var onKeyDown = onAnchorKeyDown({
      href: href,
      onClick: onClick,
      onKeyDown: anchorOnKeyDown
    });
    return /*#__PURE__*/React.createElement("a", _extends({
      className: classes,
      href: href,
      onClick: onClick,
      onKeyDown: onKeyDown,
      ref: ref
    }, getTarget(target), anchorProps), children);
  }
  var _ref2 = rest,
    buttonProps = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/React.createElement("button", _extends({
    className: classes,
    ref: ref,
    type: "button"
  }, buttonProps));
});
AlertActionButton.displayName = 'AlertActionButton';

export { AlertActionButton };
